import { Link } from "react-router-dom";
import { AlertTriangle, Info, AlertCircle } from "lucide-react";
import type { AttentionItem } from "../dashboard-selectors";

const ICON = {
  danger: AlertCircle,
  warning: AlertTriangle,
  info: Info,
} as const;

export function AttentionBar({ items }: { items: AttentionItem[] }) {
  if (items.length === 0) {
    return (
      <div className="flex items-center gap-2 rounded-xl border border-success-border bg-success-soft px-4 py-2.5 text-xs text-success">
        <span className="inline-block size-2 rounded-full bg-success" />
        All systems operational — no attention items.
      </div>
    );
  }

  return (
    <div className="flex flex-wrap items-center gap-2 rounded-xl border border-line bg-surface px-4 py-3">
      <span className="text-xs font-semibold uppercase tracking-[0.05em] text-muted">Attention:</span>
      {items.map((item, idx) => {
        const Icon = ICON[item.tone];
        return (
          <span key={item.text} className="inline-flex items-center gap-1.5 text-xs">
            <Icon className={`size-3.5 ${item.tone === "danger" ? "text-danger" : item.tone === "warning" ? "text-warning" : "text-info"}`} />
            <Link to={item.href} className="font-semibold text-ink hover:underline">
              {item.text}
            </Link>
            {idx < items.length - 1 && <span className="text-muted">·</span>}
          </span>
        );
      })}
    </div>
  );
}
